import { render, staticRenderFns } from "./brands-slug-page.vue?vue&type=template&id=a24990a6&"
import script from "./brands-slug-page.vue?vue&type=script&lang=js&"
export * from "./brands-slug-page.vue?vue&type=script&lang=js&"
import style0 from "./brands-slug-page.vue?vue&type=style&index=0&id=a24990a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports